// extracted by css-extract-rspack-plugin
export default {"dialog":"JsonSchemaDialog-module__dialog__WfFHAhp"};